import React from 'react';
import PropTypes from 'prop-types';

import includes from 'lodash/includes';
import themeable from 'zignal-landscape/lib/themeable';
import ConfirmationModal from 'zignal-landscape/lib/ConfirmationModal';
import { ROLE_INTERNAL_ADMIN } from 'containers/AppUser/AppUser.ducks';

// eslint-disable-next-line complexity
const ImportModal = (props) => {
  const {
    timezoneOffset,
    campaignId,
    estimate,
    disableImportButton,
    cancelImport,
    importStories,
    user,
    trackBaselineHistoric
  } = props;

  const hasEstimate = estimate !== null;
  const userRoles = user && user.roles || [];
  const isInternalAdmin = includes(userRoles, ROLE_INTERNAL_ADMIN);
  const limitWarningExceeded = hasEstimate && estimate > 2000000;
  const limitErrorExceeded = hasEstimate && estimate > 20000000;

  let modalConfirmStyle = 'secondary';
  let modalTitle = 'Import Estimate';
  let modalBoldText = `Approximately ${hasEstimate ? estimate.toLocaleString() : 0} stories will be imported.`;
  let modalText = `Do you want to proceed?${modalConfirmStyle === 'alert' ? ' This may take a while.' : ''}`;

  if (limitErrorExceeded && isInternalAdmin) {
    modalConfirmStyle = 'negative';
    modalBoldText = 'The estimate import size exceeds the limit of 20 million stories.';
    modalText = 'Please break down this import into smaller imports.';
  }
  else if (limitWarningExceeded) {
    modalConfirmStyle = isInternalAdmin ? 'alert' : 'negative';
    modalTitle = isInternalAdmin ? 'Import Exceeds 2 Million Stories' : 'Import Estimate';
    modalBoldText = isInternalAdmin ? modalBoldText : 'The estimate import size exceeds the limit of 2 million stories.';
    modalText = isInternalAdmin
      ? `Do you want to proceed?${modalConfirmStyle === 'alert' ? ' This may take a while.' : ''}`
      : 'Please reach out to your customer success representative to continue.';
  }

  const modalConfirmText = modalConfirmStyle === 'negative' ? 'OK' : 'Yes, Import';
  const modalOnConfirm = modalConfirmStyle === 'negative'
    ? cancelImport
    : () => importStories(campaignId, timezoneOffset, trackBaselineHistoric);

  return (
    <ConfirmationModal
      isOpen={hasEstimate}
      size="small"
      confirmText={modalConfirmText}
      onConfirm={modalOnConfirm}
      onCancel={cancelImport}
      title={modalTitle}
      confirmStyle={modalConfirmStyle}
      hideCancel={modalConfirmStyle === 'negative'}
      disableConfirm={disableImportButton}
    >
      <b>{modalBoldText}</b>
      <br />
      {modalText}
    </ConfirmationModal>
  );
};

ImportModal.propTypes = {
  timezoneOffset: PropTypes.number,
  campaignId: PropTypes.string,
  estimate: PropTypes.number,
  disableImportButton: PropTypes.bool,
  cancelImport: PropTypes.func,
  importStories: PropTypes.func,
  trackBaselineHistoric: PropTypes.object,
  user: PropTypes.object
};

export default themeable(ImportModal);
